// @flow
import React, { useCallback, useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { ErrorBoundary } from 'react-error-boundary';
import { notify, leaveBreadcrumb } from '../helpers/BugsnagClient';

import '../../static/scss/components/globalErrorBoundary.scss';

type Props = {
  children: any
};

type FallbackProps = {
  resetErrorBoundary: () => void
};

const FallbackComponent = ({ resetErrorBoundary }: FallbackProps) => {
  const location = useLocation();
  const initialLocation = useRef(location.key);

  useEffect(() => {
    if (initialLocation.current !== location.key) {
      resetErrorBoundary();
    }
  }, [location, resetErrorBoundary]);

  return (
    <div className="c-global-error-boundary">
      <h1>Something went wrong.</h1>
      <p>There has been a problem fulfilling your request</p>
      <p>
        Please{' '}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.location.reload();
          }}
        >
          reload
        </a>{' '}
        this page and try again or ask for{' '}
        <a href="https://help.justpark.com/hc/en-us">help</a> here
      </p>
    </div>
  );
};

const GlobalErrorBoundary = ({ children }: Props) => {
  const onError = useCallback((error, info) => {
    leaveBreadcrumb('GlobalErrorBoundary shown');
    notify(error, info);
  }, []);

  return (
    <ErrorBoundary FallbackComponent={FallbackComponent} onError={onError}>
      {children}
    </ErrorBoundary>
  );
};

export default GlobalErrorBoundary;
